import { inject, Injectable } from "@angular/core";
import { SecurityService } from "common";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private securityService = inject(SecurityService);

  get accountId() {
    return this.securityService.profile.selectedAccount?.accountCode;
  }

  // Turns "SIDR-000030" into 30
  get shortAccountId() {
    if (this.accountId) {
      return Number(this.accountId.split("-").pop())
    }

    return null;
  }

  get accountName() {
    return this.securityService.profile.selectedAccount?.accountName;
  }
}
